import { z } from 'zod';
import { TenantDescriptionSchema, TenantProvisioningSchema, TenantSeatLimitsSchema, TenantSlugSchema, TenantSummarySchema, TenantTypeSchema } from '../../../../entities/tenant/tenant.schema';
/**
 * Request Schema for Updating a Tenant
 * Super-admin can update tenant details
 */ export const UpdateTenantRequestSchema = z.object({
    name: z.string().min(1, 'Name is required').optional(),
    slug: TenantSlugSchema.optional(),
    active: z.boolean().optional(),
    tenantType: TenantTypeSchema.optional(),
    expiresAt: z.iso.datetime().nullable().optional(),
    /**
   * The account this workspace belongs to. A workspace belongs to a CUSTOMER,
   * and the customer is a record — so this is its id, not a company id typed
   * into a tenant form (LIC-06).
   */ accountId: z.string().optional(),
    /**
   * Deprecated in favour of {@link accountId}: the customer's HubSpot company,
   * resolved to an account behind the scenes. Kept while the tenant dialog
   * still offers the field.
   */ hubspotCompanyId: z.string().optional(),
    /**
   * Confirm overwriting an existing HubSpot company↔tenant link. Transient
   * action flag (not persisted) — only honoured when the linked company already
   * points at a different tenant; otherwise ignored.
   */ forceHubspotLink: z.boolean().optional(),
    description: TenantDescriptionSchema.optional(),
    /**
   * Per-role seat caps. Applied per field: an explicit `null` clears that pool
   * back to unlimited, an omitted field leaves it unchanged.
   */ seatLimits: TenantSeatLimitsSchema.optional(),
    /** What the tenant may set up for others; `null` takes the right away. */ provisioning: TenantProvisioningSchema.nullable().optional()
});
/**
 * Response Schema for Updating a Tenant
 */ export const UpdateTenantResponseSchema = z.object({
    message: z.string(),
    tenant: TenantSummarySchema
});

//# sourceMappingURL=update-tenant.schema.js.map